import React, {Fragment, useState, useEffect, useContext} from "react";
import {Link} from 'react-router-dom';
import "./ModalMatch.less";
import {REFERRAL_LINK} from "../../default_informations/referral_link";
import {Context} from "../Context/MatchesContext";
import crown_icon from "../../images/crown_icon.png";

function ModalMatch({matchInfo}) {
    const refLink = REFERRAL_LINK;
    const {hideModalMatchInformation, heroesArr} = useContext(Context);
    const [heroesMatch, setHeroesMatch] = useState([]);

    let start_date = matchInfo.start_time;
    let start_match = new Date(start_date * 1000);

    let year = start_match.getFullYear();
    let month = start_match.getMonth() + 1;
    if (month < 10) month = `0${month}`;
    let date = start_match.getDate();
    if (date < 10) date = `0${date}`;
    let hours = start_match.getHours();
    if (hours < 10) hours = `0${hours}`;
    let minutes = start_match.getMinutes();
    if (minutes < 10) minutes = `0${minutes}`;

    let match_date = `${date}.${month}.${year}`;
    let match_time = `${hours}:${minutes}`;

    let now_year = new Date().getFullYear();
    let now_month = new Date().getMonth() + 1;
    if (now_month < 10) now_month = `0${now_month}`;
    let now_date = new Date().getDate();
    if (now_date < 10) now_date = `0${now_date}`;

    let date_now = `${now_date}.${now_month}.${now_year}`;
    let time_now = `${new Date().getHours()}:${new Date().getMinutes()}`;

    let match_duration = matchInfo.duration;
    let match_duration_seconds = match_duration % 60;
    let match_duration_minutes = (match_duration - match_duration_seconds) / 60;
     if (match_duration_seconds < 10) match_duration_seconds = `0${match_duration_seconds}`;
    match_duration = `${match_duration_minutes}:${match_duration_seconds}`;

    useEffect(() => {
        let hero_arr = [];
        for (let i = 0; i < matchInfo.players.length; i++) {
            heroesArr.filter(item => {
                if (item.id === matchInfo.players[i].hero_id) {
                    item.personaname = matchInfo.players[i].personaname;
                    hero_arr.push(item)
                }
                return null;
            })
        }
        setHeroesMatch(hero_arr);

        return () => {
            setHeroesMatch([]);
        }
    }, [matchInfo, heroesArr]);

    function modalOverflow(event) {
        if (event.target.className === 'gg-modal-match enter-done') {
            hideModalMatchInformation();
        }
    }

    return (
        <div className="gg-modal-match" onClick={e => modalOverflow(e)}>
            <div className="modal-content">
                <div className="modal-header">
                    <p className="modal-title">{matchInfo.radiant_team.name} vs {matchInfo.dire_team.name}</p>
                    <p className="match-duration">{`Продолжительность матча - ${match_duration}`}</p>
                    <button
                        className="close-modal"
                        onClick={() => hideModalMatchInformation()}
                    >
                        <svg className="tour-icon" width="16" height="16" viewBox="0 0 16 16">
                            <use xlinkHref="#arrow-left_3c6dd" />
                        </svg>
                    </button>
                </div>
                <div className="modal-body">
                    <div className="league-name">
                        <svg className="tour-icon" width="20" height="20" viewBox="0 0 80 80">
                            <use xlinkHref="#esports_dota_2_81226" />
                        </svg>
                        <span>{matchInfo.league.name}</span>
                    </div>
                    <div className="match-teams">
                        <div className={matchInfo.radiant_win ? "team first win" : "team first"}>
                            <span className="team-logo">
                                <img
                                    src={Boolean(matchInfo.radiant_team.logo_url) ? matchInfo.radiant_team.logo_url : '../img/no_team_logo.png'}
                                    alt={matchInfo.radiant_team.name}
                                />
                            </span>
                            <span className="team-name">{matchInfo.radiant_team.name}</span>
                            <span className="crown_icon" style={{backgroundImage: `url(${crown_icon})`}} />
                        </div>
                        <div className="match-start">
                            <Fragment>
                                <span className="date">{match_date}</span>
                                <span className="time">{match_time}</span>
                            </Fragment>
                        </div>
                        <div className={!matchInfo.radiant_win ? "team second win" : "team second"}>
                            <span className="team-logo">
                                <img
                                    src={Boolean(matchInfo.dire_team.logo_url) ? matchInfo.dire_team.logo_url : '../img/no_team_logo.png'}
                                    alt={matchInfo.dire_team.name}
                                />
                            </span>
                            <span className="team-name">{matchInfo.dire_team.name}</span>
                            <span className="crown_icon" style={{backgroundImage: `url(${crown_icon})`}} />
                        </div>
                    </div>
                    <div className="match-score">
                        <p className="score-title">Счёт</p>
                        <ul className="score-result">
                            <li className="score first">
                                <a href={refLink} rel="nofollow noopener noreferrer" target="_blank">{date_now === match_date && time_now < match_time ? '-' : matchInfo.radiant_score}</a>
                            </li>
                            <li className="vs">vs</li>
                            <li className="score second">
                                <a href={refLink} rel="nofollow noopener noreferrer" target="_blank">{date_now === match_date && time_now < match_time ? '-' : matchInfo.dire_score}</a>
                            </li>
                        </ul>
                    </div>
                    <div className="place-bet">
                        <a className="bet-link" href={refLink} rel="nofollow noopener noreferrer" target="_blank">Сделать ставку</a>
                    </div>
                    <div className="match-picks">
                        {
                            heroesMatch.length ? (
                                <Fragment>
                                    <ul className="team-picks first">
                                        <li className="pick-team">Силы Света</li>
                                        <li className="pick">
                                            <p className="hero-image">
                                                <img className="image" src={`../img/heroes/${heroesMatch[0].name}.png`} alt={heroesMatch[0].localized_name} title={heroesMatch[0].localized_name} />
                                                <span className="name" title={heroesMatch[0].localized_name}>{heroesMatch[0].localized_name}</span>
                                            </p>
                                            <p className="player">{Boolean(matchInfo.players[0].name) ? matchInfo.players[0].name : heroesMatch[0].personaname}</p>
                                        </li>
                                        <li className="pick">
                                            <p className="hero-image">
                                                <img className="image" src={`../img/heroes/${heroesMatch[1].name}.png`} alt={heroesMatch[1].localized_name} title={heroesMatch[1].localized_name} />
                                                <span className="name" title={heroesMatch[1].localized_name}>{heroesMatch[1].localized_name}</span>
                                            </p>
                                            <p className="player">{Boolean(matchInfo.players[1].name) ? matchInfo.players[1].name : heroesMatch[1].personaname}</p>
                                        </li>
                                        <li className="pick">
                                            <p className="hero-image">
                                                <img className="image" src={`../img/heroes/${heroesMatch[2].name}.png`} alt={heroesMatch[2].localized_name} title={heroesMatch[2].localized_name} />
                                                <span className="name" title={heroesMatch[2].localized_name}>{heroesMatch[2].localized_name}</span>
                                            </p>
                                            <p className="player">{Boolean(matchInfo.players[2].name) ? matchInfo.players[2].name : heroesMatch[2].personaname}</p>
                                        </li>
                                        <li className="pick">
                                            <p className="hero-image">
                                                <img className="image" src={`../img/heroes/${heroesMatch[3].name}.png`} alt={heroesMatch[3].localized_name} title={heroesMatch[3].localized_name} />
                                                <span className="name" title={heroesMatch[3].localized_name}>{heroesMatch[3].localized_name}</span>
                                            </p>
                                            <p className="player">{Boolean(matchInfo.players[3].name) ? matchInfo.players[3].name : heroesMatch[3].personaname}</p>
                                        </li>
                                        <li className="pick">
                                            <p className="hero-image">
                                                <img className="image" src={`../img/heroes/${heroesMatch[4].name}.png`} alt={heroesMatch[4].localized_name} title={heroesMatch[4].localized_name} />
                                                <span className="name" title={heroesMatch[4].localized_name}>{heroesMatch[4].localized_name}</span>
                                            </p>
                                            <p className="player">{Boolean(matchInfo.players[4].name) ? matchInfo.players[4].name : heroesMatch[4].personaname}</p>
                                        </li>
                                    </ul>
                                    <ul className="team-picks second">
                                        <li className="pick-team">Силы Тьмы</li>
                                        <li className="pick">
                                            <p className="hero-image">
                                                <img className="image" src={`../img/heroes/${heroesMatch[5].name}.png`} alt={heroesMatch[5].localized_name} title={heroesMatch[5].localized_name} />
                                                <span className="name" title={heroesMatch[5].localized_name}>{heroesMatch[5].localized_name}</span>
                                            </p>
                                            <p className="player">{Boolean(matchInfo.players[5].name) ? matchInfo.players[5].name : heroesMatch[5].personaname}</p>
                                        </li>
                                        <li className="pick">
                                            <p className="hero-image">
                                                <img className="image" src={`../img/heroes/${heroesMatch[6].name}.png`} alt={heroesMatch[6].localized_name} title={heroesMatch[6].localized_name} />
                                                <span className="name" title={heroesMatch[6].localized_name}>{heroesMatch[6].localized_name}</span>
                                            </p>
                                            <p className="player">{Boolean(matchInfo.players[6].name) ? matchInfo.players[6].name : heroesMatch[6].personaname}</p>
                                        </li>
                                        <li className="pick">
                                            <p className="hero-image">
                                                <img className="image" src={`../img/heroes/${heroesMatch[7].name}.png`} alt={heroesMatch[7].localized_name} title={heroesMatch[7].localized_name} />
                                                <span className="name" title={heroesMatch[7].localized_name}>{heroesMatch[7].localized_name}</span>
                                            </p>
                                            <p className="player">{Boolean(matchInfo.players[7].name) ? matchInfo.players[7].name : heroesMatch[7].personaname}</p>
                                        </li>
                                        <li className="pick">
                                            <p className="hero-image">
                                                <img className="image" src={`../img/heroes/${heroesMatch[8].name}.png`} alt={heroesMatch[8].localized_name} title={heroesMatch[8].localized_name} />
                                                <span className="name" title={heroesMatch[8].localized_name}>{heroesMatch[8].localized_name}</span>
                                            </p>
                                            <p className="player">{Boolean(matchInfo.players[8].name) ? matchInfo.players[8].name : heroesMatch[8].personaname}</p>
                                        </li>
                                        <li className="pick">
                                            <p className="hero-image">
                                                <img className="image" src={`../img/heroes/${heroesMatch[9].name}.png`} alt={heroesMatch[9].localized_name} title={heroesMatch[9].localized_name} />
                                                <span className="name" title={heroesMatch[9].localized_name}>{heroesMatch[9].localized_name}</span>
                                            </p>
                                            <p className="player">{Boolean(matchInfo.players[9].name) ? matchInfo.players[9].name : heroesMatch[9].personaname}</p>
                                        </li>
                                    </ul>
                                </Fragment>
                            ) : null
                        }
                    </div>
                    <div className="place-bet">
                        <Link to="/all-heroes/">Все герои</Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalMatch;